import type { RenewalDetails } from '@policyvision/contracts';
import { useQuery } from '@tanstack/react-query';

import { fetchRenewalDetails } from '../api/FetchRenewalDetails';

export function useFetchRenewalById(uuid: string | undefined) {
  const { data, isLoading, error } = useQuery<RenewalDetails>({
    queryKey: ['renewal', uuid],
    queryFn: () => fetchRenewalDetails(uuid!),
    enabled: !!uuid,
  });

  return {
    renewalDetails: data,
    isLoading,
    error,
  };
}
